// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__3ihfs","spinner":"Loader_spinner__4krVl"};